import { useMutation } from "@tanstack/react-query";
import PaymentService from "../services";
import { Card } from "../paymentsType/Card"; 

type CreateCardInput = {
    paymentMethodId: string;
    customerId: string;
  };

const useCreateCard = () => {
    return useMutation({
      mutationFn: async (newCard: { paymentMethodId: string; customerId: string }) => {
        const response = await PaymentService.create(newCard);
        return response.data; // or response.json(), based on your API
      },
      onError: (error) => {
        console.error("Error creating card:", error);
      },
      onSuccess: (data) => {
      },
    });
  };

export default useCreateCard;